import React, { HTMLAttributes } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '../query'

const QueryProvider = ({ children }: HTMLAttributes<HTMLElement>) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {process.env.REACT_APP_ENV !== `production` && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}

export default QueryProvider
